import { ENABLED_PADDING_KEYS, ENABLED_RADIUS_KEYS } from '@/interfaces/widgetTheme/spacing';
import { getPaddingMultiplierFromKey, getRadiusMultiplier } from '@/services/widgetTheme';
import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const SPACING = derivedThemeValues(_ref => {
  let {
    padding,
    radius
  } = _ref;
  return {
    // Calculate padding values based on their base rem value
    padding: ENABLED_PADDING_KEYS.reduce((acc, key) => {
      const value = getPaddingMultiplierFromKey(key);
      acc[key] = padding(value);
      return acc;
    }, {}),
    // Calculate radius values based on their base rem value
    radius: ENABLED_RADIUS_KEYS.reduce((acc, key) => {
      acc[key] = radius(getRadiusMultiplier(key));
      return acc;
    }, {})
  };
});